import React, { Component } from 'react'
import { toast } from 'react-toastify'

import { Button } from '@/components/Button'
import { Switch } from '@/components/Switch'
import { Spinner } from '@/components/Spinner'
import FCDBIngredientSelector from '@/features/ingredients/FCDBIngredientSelector'

import IngredientEntry from './IngredientEntry'
import { Label } from '@/components/Label'
import {
  createOrUpdateFoodRestriction,
  deleteFoodRestriction,
  getFoodRestriction,
} from '@/api/foodRestrictions'

const defaultFoodRestriction = {
  enabled: false,
  name: '',
  ingredientsToExclude: [],
  selectingExclude: false,
}

export default class EditOrCreateFoodRestriction extends Component<any, any> {
  state: any = {}

  componentDidMount() {
    this.loadFoodRestriction()
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.loadFoodRestriction()
    }
  }

  loadFoodRestriction = () =>
    this.setState({ foodRestriction: undefined }, () =>
      this.props.restrictionId !== undefined
        ? getFoodRestriction(this.props.restrictionId)
            .then((foodRestriction) => this.setState({ foodRestriction, isNew: false }))
            .catch(() => {
              toast.error('Error loading food restriction')
              this.setState({ foodRestriction: defaultFoodRestriction, isNew: true })
            })
        : this.setState({ foodRestriction: defaultFoodRestriction, isNew: true }),
    )

  handleChange = (evt) =>
    this.setState({
      foodRestriction: {
        ...this.state.foodRestriction,
        [evt.target.name]: evt.target.value,
      },
    })

  save = () =>
    createOrUpdateFoodRestriction(this.state.foodRestriction)
      .then((foodRestriction) => {
        if (this.state.isNew) {
          this.props.navigate({ to: `/food-restrictions/${foodRestriction.idFoodRestriction}` })
        }

        toast.success('Food restriction was saved successfully')
      })
      .catch((error) => toast.error(error?.message))

  deleteRestriction = () =>
    confirm('Are you sure you want to delete this food restriction?') &&
    deleteFoodRestriction(this.state.foodRestriction.idFoodRestriction).then(() => {
      toast.success('Food restriction was deleted successfully')
      this.props.navigate({ to: '/food-restrictions' })
    })

  render() {
    const { foodRestriction, isNew, selectingAvoid, selectingExclude } = this.state
    const { ingredientsToAvoid, ingredientsToExclude } = foodRestriction || {}
    return (
      <div style={{ padding: '20px' }}>
        {foodRestriction ? (
          <>
            <div className="viewHeader row">
              <div className={'viewHeader-title col-md-8'}>
                <Label>Name</Label>
                <input
                  className=" form-control"
                  type="text"
                  placeholder="Name"
                  name="name"
                  value={foodRestriction.name}
                  onChange={this.handleChange}
                />
              </div>

              <div className="viewHeader-controls col-md-4">
                {/* {!isNew && (
                  <Button variant="negative" onPress={this.deleteRestriction}>
                    Delete Restriction
                  </Button>
                )} */}
                <Button variant="primary" onPress={this.save} style={{ float: 'right' }}>
                  Save restriction
                </Button>
              </div>
            </div>
            <div>
              <div className="mb-4">
                <Switch
                  isSelected={foodRestriction.enabled}
                  onChange={(value) => this.handleChange({ target: { name: 'enabled', value } })}>
                  Users able to select this food restriction
                </Switch>
              </div>
              <div className="row">
                <div className="col">
                  <h3>Exclude</h3>
                  <FCDBIngredientSelector
                    selection={ingredientsToExclude}
                    onChangeSelection={(selection) =>
                      this.setState({
                        selectingExclude: false,
                        foodRestriction: {
                          ...foodRestriction,
                          ingredientsToExclude: selection,
                        },
                      })
                    }
                  />
                  {ingredientsToExclude && ingredientsToExclude.length === 0 ? (
                    <div className="emptyState">No ingredients</div>
                  ) : (
                    <>
                      {ingredientsToExclude.map((ingredient) => (
                        <IngredientEntry
                          key={ingredient.idIngredient}
                          ingredient={ingredient}
                          onRemove={() =>
                            this.setState({
                              foodRestriction: {
                                ...foodRestriction,
                                ingredientsToExclude: ingredientsToExclude.filter(
                                  (ing) => ing.idIngredient !== ingredient.idIngredient,
                                ),
                              },
                            })
                          }
                        />
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <Spinner />
        )}
      </div>
    )
  }
}
